var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.leftNavData)?_c('div',[_c('b-button',{on:{"click":_vm.addNew}},[_vm._v(" Add ")]),_c('draggable',{staticClass:"content__wrapper",attrs:{"list":_vm.leftNavData},on:{"end":_vm.reorder}},_vm._l((_vm.leftNavData),function(item){return _c('div',{key:item.id},[_c('item',{attrs:{"left-nav-item":item}})],1)}),0)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }